// extracted by mini-css-extract-plugin
export default {"message":"styles_message__a9pQ4","my":"styles_my__k9wT7","content":"styles_content__Qr0cu","footer":"styles_footer__R-oPe","time":"styles_time__B0XYr"};